import parseHTML from "../../lib/dom/funciones/parse_html";
const videos = () => {
    Array.from(document.querySelectorAll('.bloque--videos')).forEach((el) => {
        const navegacion = parseHTML('<div class="videos__navegacion animado"></div>');
        const lista = el.querySelector('.videos__lista');
        const bolitas = Array.from(lista.querySelectorAll('.videos__video')).map((el, i) => {
            const bolita = parseHTML(`<button aria-pressed="${i === 0 ? 'true' : 'false'}" class="videos__bolita"></button>`);
            bolita.innerHTML = '<img src="' + el.dataset.miniatura + '" alt="" />';
            bolita.addEventListener('click', () => {
                lista.scroll({
                    left: elemento.offsetLeft * i,
                    behavior: 'smooth'
                });
            });
            return bolita;
        });
        bolitas.forEach((bolita) => navegacion.appendChild(bolita));
        el.appendChild(navegacion);
        const elemento = lista.querySelector('.videos__video:nth-child(2)');
        lista.addEventListener('scroll', () => {
            const indiceActivo = Math.round(lista.scrollLeft / lista.scrollWidth * bolitas.length);
            bolitas.forEach((bolita, i) => {
                bolita.ariaPressed = i === indiceActivo ? 'true' : 'false';
            });
        });
    });
};
export default videos;
